<template>
  <q-btn
    class="list-property-btn border-radius-xl"
    :label="$t('listYourProperty')"
    no-caps
    outline
    text-color="primary"
    :to="{ name: 'list-property' }"
    unelevated
  />
</template>

<script lang="ts" setup>
//
</script>

<style lang="scss">
.list-property-btn {
  font-size: 0.875rem;
  font-weight: 700;
}
</style>
